export default __webpack_public_path__ + "static/media/flag-peru.dcc67150.svg";